// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description = "This widget works as a visual pointer to an external URL.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "External content embed",
  id: "external-content-embed",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/external-content-embed/?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "ExternalContentEmbedConfigTool" */ "app/components/tools/ExternalContentEmbedConfigTool/ExternalContentEmbedConfigTool"),
    loading: DynamicImportLoader,
    modules: ["ExternalContentEmbedConfigTool"]
  })
};

export default CONFIG;
